(function() { module.exports = window["Bernie_l10nBundle_ms_MY"]; }());